const baseStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  fontSize: 15,
  paddingRight: 2,
  paddingBottom: 3,
};

const checked = {
  ...baseStyle,
  color: '#F2F2F2',
};

const unchecked = {
  ...baseStyle,
  color: '#666666',
};

export const checkedWraper = <div style={checked}>sim</div>;

export const uncheckedWraper = <div style={unchecked}>não</div>;
